import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/**
 * Order-level shipment details: `orders.freight_weight_lbs`,
 * `orders.commodity_code`, `orders.commodity_description`.
 */
export function ShipmentFields({
  freightWeightLbs,
  commodityCode,
  commodityDescription,
  onFreightWeightChange,
  onCommodityCodeChange,
  onCommodityDescriptionChange,
  disabled,
  commodityCodeRequired = true,
}: {
  freightWeightLbs: string;
  commodityCode: string;
  commodityDescription: string;
  onFreightWeightChange: (v: string) => void;
  onCommodityCodeChange: (v: string) => void;
  onCommodityDescriptionChange: (v: string) => void;
  disabled?: boolean;
  commodityCodeRequired?: boolean;
}) {
  return (
    <div className="space-y-3">
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <Label htmlFor="freight-weight">Freight weight (lbs)</Label>
          <Input
            id="freight-weight"
            type="number"
            inputMode="decimal"
            min={0}
            value={freightWeightLbs}
            onChange={(e) => onFreightWeightChange(e.target.value)}
            placeholder="e.g., 42000"
            disabled={disabled}
          />
        </div>
        <div>
          <Label htmlFor="commodity-code">
            Commodity code{commodityCodeRequired ? " *" : ""}
          </Label>
          <Input
            id="commodity-code"
            value={commodityCode}
            onChange={(e) => onCommodityCodeChange(e.target.value)}
            placeholder="e.g., 1234"
            maxLength={40}
            disabled={disabled}
          />
        </div>
      </div>
      <div>
        <Label htmlFor="commodity-description">Commodity description</Label>
        <Textarea
          id="commodity-description"
          value={commodityDescription}
          onChange={(e) => onCommodityDescriptionChange(e.target.value)}
          placeholder="What's on the trailer?"
          maxLength={500}
          rows={2}
          disabled={disabled}
        />
      </div>
    </div>
  );
}